export default {"src":"/_next/static/media/term-browser.d072cd52.svg","height":57,"width":54,"blurWidth":0,"blurHeight":0};